import {FC} from 'react';
import classNames from 'classnames';
import EditableField from '../../common/fields/EditableField';
import {CellItemProps} from '../../../constants/types';
import {
  relRangeValidationSchema,
  absRangeValidationSchema
} from '../../../constants/validationSchemes';

type RowProps = {
  processType: string,
  cellItem: CellItemProps,
  isRelative: boolean,
  isTimeInput?: boolean,
  firstCellClassName?: string;
}

const Row: FC<RowProps> = ({
  processType, cellItem, isRelative, firstCellClassName, isTimeInput
}) => {
  return (
    <tr className="row">
      <td className={classNames('cell', {[`${firstCellClassName}`]: !!firstCellClassName})}>
        {processType}
      </td>
      <td className="cell">
        <EditableField
          isTimeInput
          cellItem={cellItem}
          separator={' : '}
          validationSchema={isRelative ?
            relRangeValidationSchema :
            absRangeValidationSchema} />
      </td>
    </tr>
  );
};

export default Row;
